import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs"

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import inprogress from "../../assets/Images/inprogress.png";

import cat1 from "../../assets/Images/infomonitor.png";

import logo1 from "../../assets/Images/sketches.jpg";
import logo2 from "../../assets/Images/studioname.png";

import cat2 from "../../assets/Images/catsketches.jpg";




import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";
import Slideshow from "../../assets/Slideshow/Slideshow"; 


import mconcept1 from "../../assets/Images/progress/mascot.jpg"; 

import fconcept from "../../assets/Images/progress/fconcept.jpg";
import fconcept2 from "../../assets/Images/progress/fconcept2.GIF"; 










const Lo1Concept = () => {
    const navigate = useNavigate();

    const images = [lowprot1, lowprot2, figma];
    const images2 = [inprogress]
    const images3 = [cat1]
    const images4 = [logo1, logo2]
    const images5 = [cat2]
    const images6 = [fconcept,fconcept2]
    const images7 = [mconcept1]

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo1-headings">
                <h1>Concept and Design Proof of Concept</h1>
                <p>The main idea behind my products and how it should respond to user problem and offer a value, and creating wireframe, lo-fi, hi-fi.</p>

                
            </div>

            <div className="line"></div>

            <div style={{ padding: '0.1rem 7.5rem' }}>
                            <BreadcrumbHeader />
            </div>

            <div className="content-lo1">
                <div className="content-lo1-concept">
                    <div className="content-lo1-concept-text">
                    {/* <img src={gif2}></img> */}
                        <h1>The concept of Octolume</h1>
                        <p>
                            We first meet eachother during the first gathering and create a group, we did a brainstorm to find each
                            other strenghts and weaknesses. We then discussed what we want to do and what we want to name our group.
                             
                        </p>
                        <h2>
                            What are our member's strenghts?
                        </h2>
                        <p>
                            I note down my strengths and weaknesses to find out what I could do for our group or studio, after we discussed we list a few things what this group/studio
                            could do for our future projects, which are:
                            <ul>
                                <li>Web Development</li>
                                <li>Mobile App Development</li>
                                <li>Graphic Design</li>
                            </ul>
                            
                        </p>

                        <h2>What is our Core Values?</h2>
                        <p>
                            We also thought about what is the core values that we represent, we come up with the core values of being adaptable
                            and flexible, because we came from different region and we could connect with each other.
                        </p>

                        <h2>Forming a Brand</h2>
                        <p>
                            At the end I come up with a name that is Octolume, our group name represent our core values, as an Octopus we are
                            adaptable and flexible, and why we use lume is because we as a studio wants to guide and show the path for our client
                            with the light. (lumos;lume)

                        </p>

                        
                        
                        
                    </div>

                    <div className="content-lo1-concept-text2">
                        <h1>Clients Project Concept</h1>
                        <p>
                            For our client project we were assigned to a client, Fontys Marketing. We as a group have to make a marketing campaign
                            for a new minor that is called Virtual Production
                        </p>
                        <h2>Research</h2>
                        <p>
                            My group and I did a basic research about virtual production to find out what is virtual production. After researching we 
                            gather and come up with a conclusion that virtual production is a process of making a film where it is available to change
                            surrounding and environment with the tools virtual production have in offer.
                        </p>
                        <h2>Client Meeting</h2>
                        <p>
                            We scheduled a meeting to our client to find out what they needs and expectation. We prepared an interview question <a href="https://docs.google.com/document/d/1NACwKOLECi2V2TTBjhbfw1oZTnWlcYJFO9Ya1DmxzZM/edit?usp=drive_link">here</a>.
                            After the meeting we found out what our client needs and wants. She also provided assets that we could use to help our task
                            in marketing the Virtual Production Minor.

                        </p>
                        <h2>Research Questions</h2>
                        <p>
                            We then come up with research question, Primary and Secondary. For the primary:
                            <ul>
                                <li>How to choose a minor?</li>
                            </ul>
                            and for the scondary:
                            <ul>
                                <li>Does Social media play a role in minor choice</li>
                                <li>How does university culture and resources impact studet's desicions?</li>
                                <li>Does choosing a minor improve job satisfaction and career flexibility?</li>
                                <li>How to reach people who are passionate about the minor?</li>
                                <li>does the staff / vibe affect decisions?</li>
                            </ul>
                            For this I was given the task to answer the fifth question

                        </p>
                        <h2>Interviews</h2>
                        <p>
                            As a groupmate I helped in making the interview questions for the students.
                            After the interview is done we also interviewed the mentors that is connected with our client. Here are the questions?
                            <ul>
                                <li>What is the minor Virtual production about?</li>
                                <li>Outside of the creative industry, what can virtual production be used for?</li>
                                <li>What technology and software will be used during this minor?</li>
                                <li>What skills will students learn in this minor?</li>
                                <li>What kind of projects will students create?</li>
                                <li>How and what work environment will students experience?</li>
                                <li>Will there be guest lectures or collaborations within this minor?</li>
                                <li>How is the minor structured?(Projects, Modules or assessments)</li>

                            </ul>
                        </p>
                        <h2>Observation</h2>
                        <p>Observation on Pixel Playground</p>
                        <p>Observation around campus</p>
                        <h2>Final Concept</h2>
                        <p>
                            For final concept My group and I discussed with what we can do for the final concept. You can see our concept Document <a href="https://docs.google.com/document/d/1Jh-CLR6oaXUSp_g4Qr4iH7FX8d3TAkgkt0__RsgX8_s/edit?usp=drive_link">here</a> and the target audience <a href="https://docs.google.com/document/d/1B8hvipR2KldS1bhpBcmZCGzsbshqjErxAGwksb5_1K8/edit?usp=drive_link">here</a>

                        </p>

                    </div>

                    <div className="content-lo1-concept-text3">
                        <h1>Cat meme as a campaign</h1>
                        <p>
                            We chose to use cat memes as a theme for our campaign because they are easily and widely recognized,
                            humorous, and the chance to get it spread is high especially among our target audience:students.

                        </p>
                        <h2>Why is using cat memes a good strategy?</h2>
                        <p>Cat memes trigger emotional response such as amusement or joy, what we are doing is basically emotional
                            maketing. This fits perfectly with what we want to do which is to make our campaign unique and authentic.
                            since nowdays students constantly gets information throughtout their routines, seeing something funny and
                            visually attracting could make them remember important messages.
                        </p>
                    </div>


                    <div className="content-lo1-concept-text4">
                    {/* <img src={gif2}></img> */}
                        <h1>How did I plan this portfolio</h1>
                        <h2>Low Fidelity</h2>
                        <p>
                            The design process for my portfolio, I started with some basic sketches on my book
                            to visualize the layout and overall concept. After I have asome idea of what I want
                            to make, I discuss with Amer and received a positive feedback to try and make this 
                            website. One of the feedback that I got is to maybe try make a 3D face model on the 
                            homepage to make it captivating for the viewer, and to help my portfolio stand out.
                        </p>
                        <h2>Mid Fidelity</h2>
                        <p>
                            After I'm done with sketching, I tried to make a better design on figma. This step
                            helps me in making this website/ portfolio structured and organized, where I can try
                            moving the layout, colors, to try Interacting with this design.
                        </p>
                        <h2>High Fidelity</h2>
                        <p>
                            For this phase, I try to develop this portfolio website. This involves in translating
                            the visual design into a working digital product using HTML, CSS, Javascript, and React
                        </p>
                        
                    </div>

                    <div className="content-lo1-concept-text5">
                        <h1>Logo Design</h1>
                        <p>
                            The concept for our group logo is basically an Octopus with a light
                        </p>
                        <h2>Why do we want that for our logo?</h2>
                        <p>
                            We want to have our core values in our logo, so we use an octopus and light as our representation, and why octopus and light
                            that is because octopus represent our core values which are adaptable and flexible, and why light is because we want to show
                            that we can guide and help our client with our light in the ocean.
                        </p>
                        <h2>How did we make it?</h2>
                        <p>
                            Each of our group member create their own version of the logo for our studio and after we come up with each version that we 
                            make, we then took a vote to choose the logo that we want for our group/studio
                        </p>
                        {/* <h1>Logo Design</h1>
                        <p>
                            I made this logo using Adobe Illustrator, from the sketch that one of my group mates made. I tried to digitalized it so and this was the last version that I made.

                            The first step that we took was actually to design each of our logo and have a vote between our logo

                            So this logo was made from my groupmates idea where this Octopus holds a light where the idea was that we could guide our clients with our light

                            During this phase I continue to itterate towards all the feedback that was given from teachers and students.

                            But at the end one of my groupmate sam manage to do a better design where we all agree to use it as our brand logo, you can see it on the right
                        </p> */}
                    </div>

                    <div className="content-lo1-concept-text6">
                        <h1>3D Poster and Arduino</h1>
                        <p>
                            For this concept Adib and I explored a creative ways to make our promotional material more interactive and eye-catching. Rather than sticking to traditional
                            2D posters, we wanted something that would physically stand out and spark curiosity. Our goal was to create a marketing tactic that not only informs but also
                            engaging and playful.
                        </p>
                        <h2>Combining Design and Technology</h2>
                        <p>
                            In keeping with the campaign's theme, we created an eye-catching poster and 3D printed a cat figure. A 3D poster was created by combining these two elements,
                            transforming a flat image into a dynamic display. The 3D cat serves as a playful figure and could be instantly recognized by our target audience.
                        </p>
                        <h2>Adding Arduino to make it more interactive</h2>
                        <p>
                            To take the concept further, we integrated an Arduino setup with an ultrasonic sensor and a speaker module. The sensor detects motion when someone walks by,
                            triggering a cat sound . This unexpected audio will create a surprise and humor, increasing the chances that passersby stop and engage with the poster.
                        </p>
                        <h2>Why would this works?</h2>
                        <p>
                            This combination of physical presence, humor, and interactivity makes the poster more than just a piece of paper—it becomes an experience. It reflects the
                            theme of our campaign (cat memes and student engagement), while also showcasing how playful tech can be used in real-world marketing. The unexpected sound
                            element, paired with the 3D design, successfully draws attention and invites people to come closer, scan the QR code, and learn more about the Virtual Production minor.
                        </p>
                    </div>

                    <div className="content-lo1-concept-text7">
                        <h1>3D Model for Homepage</h1>
                        <h2>Concept</h2>
                        <p>
                            I wanted my portfolio homepage to leave a strong first impression. Inspired by feedback from one of my teacher Amer, I plan to make a 3D model that follows
                            user's cursor. This adds a layer of interactivity and gives visitor a feeling that this portfolio is alive and responsive.
                        </p>
                        <h2>User Problem & Value</h2>
                        <p>Most student portfolio follows a standard layout and feel quite similar. This 3D model could help my portfolio stand out by being memorable and engaging. It reflects
                            creativity, technical skill, and my interest in making a better design for a website.
                        </p>
                        <h2>Design Process</h2>
                        <ul>
                            <li>Wireframe & Lo-fi: I started sketching in my notebook to plan layout and what this 3D could look like</li>
                            <li>Lo to mid-fi: I tried to make the 3D model of my face on procreate to animate it and see if it looks interesting</li>
                            <li>Hi-fi: I used blender to import the 3D model that was made on an application, to sculpt it and try to render it on my portfolio</li>
                        </ul>
                        
                    </div>

                    <div className="content-lo1-concept-text8">
                        <h1>3D Mascot for Marketing Campaign</h1>
                        <h2>Concept</h2>
                        <p>
                            As part of Octolume's campaign for the virtual production minor, I develop a 3D cat mascot to align it with our campaign themes which is cat memes.
                            the idea of making this mascot was suggested by one of my teacher Jan to tie this with our campaign.
                        </p>
                        <h2>User Problem & Value</h2>
                        <p>
                            Our campaign needed to grab attention in a busy student environment. Many students ignore posters, but with a physical mascot that makes a sound when they walk by?
                            That creates curiousity. The mascot draws people in and encourages interaction.
                        </p>
                        <h2>Design Process</h2>
                        <ul>
                            <li>Wireframe & Lo-fi: I sketch the cat mascot that I want to make on procreate, and also with a help form my groupmate Debora, she manage to make the mascot for me to use it as a reference</li>
                            <li>Mid-fi: Using Debora's design as a refrence I translate this sketch drawing into blender</li>
                            <li>Hi-fi: I create low-poly cat mascot in Blender, 3D printed it, and use Arduino + ultrasonic sensor + speaker</li>
                        </ul>
                        
                    </div>

                    {/* <div className="content-lo1-concept-slideshow">
                        <Slideshow images={images2} />

                    </div>

                    
                    <div className="content-lo1-concept-slideshow2">
                        <Slideshow images={images2} />

                    </div> */}

                    <div className="content-lo1-concept-slideshow3">
                        <Slideshow images={images3} />

                    </div>

                    <div className="content-lo1-concept-slideshow4">
                        <Slideshow images={images} />

                    </div>

                    <div className="content-lo1-concept-slideshow5">
                        <Slideshow images={images4} />

                    </div>

                    <div className="content-lo1-concept-slideshow6">
                        <Slideshow images={images5} />

                    </div>

                    <div className="content-lo1-concept-slideshow7">
                        <Slideshow images={images6} />

                    </div>
                    

                    <div className="content-lo1-concept-slideshow8">
                        <Slideshow images={images7} />

                    </div>
                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo1Concept;